import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store';

type State = {
  dimensionsDropdownOpened: boolean;
  metricsDropdownOpened: boolean;
};

const initialState: State = {
  dimensionsDropdownOpened: false,
  metricsDropdownOpened: false,
};

export const layerAggregateSlice = createSlice({
  name: 'layerAggregateSlice',
  initialState,
  reducers: {
    // TODO: HACK HACK HACK, SUPER HACK HACK, SUPER SUPER HACK... 🏎️
    // TODO: Remove this on refactoring please
    openDimensionsDropdown: (
      state,
      action: PayloadAction<State['dimensionsDropdownOpened']>,
    ) => {
      state.dimensionsDropdownOpened = action.payload;
    },
    openMetricsDropdown: (
      state,
      action: PayloadAction<State['metricsDropdownOpened']>,
    ) => {
      state.metricsDropdownOpened = action.payload;
    },
  },
});

export const { openDimensionsDropdown, openMetricsDropdown } =
  layerAggregateSlice.actions;

export const selectDimensionsDropdownOpened = (state: RootState) =>
  state.layerAggregateSlice.dimensionsDropdownOpened;

export const selectMetricsDropdownOpened = (state: RootState) =>
  state.layerAggregateSlice.metricsDropdownOpened;
